import React, { useState, useEffect, useMemo } from 'react';
import { graphql } from "gatsby";
import parse from 'html-react-parser';
import useTeamMemberQuery from '../../../hooks/use-team-member-query';
import TeamCard from "../../cards/team";
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";
import { Close, Search } from "../../icons";
import StructuredText from "../custom-structured-text-renderer";
import Select from 'react-select';
import sal from 'sal.js';

const TeamArchive = ({ title }) => {
    const [popup, setPopup] = useState(false);
    const [profile, setProfile] = useState(null);
    const teamMembers = useTeamMemberQuery();
    const [state, setState] = useState({});
    const [currentSector, setCurrentSector] = useState('');
    const [searchText, setSearchText] = useState('');

    const sectors = [...new Set([...teamMembers.flatMap(a => a.sector.map(b => b.option))].filter(Boolean))];
    const options = [
        { value: '', label: 'Filter' },
        ...sectors.map(el => ({ value: el, label: el })) || []
    ];

    useEffect(() => {
        sal();
    }, [currentSector, searchText]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const value = e.target.search.value;
        setState({ ...state, search: value });
    };

    const filteredTeam = useMemo(() => {
        let filteredTeam = teamMembers;
        if (currentSector) {
            filteredTeam = filteredTeam.filter(el => el.sector.some(sec => sec.option === currentSector));
        }

        if (searchText) {
            const searchTerms = searchText.toLowerCase().split(' ');
            filteredTeam = filteredTeam.filter(team => searchTerms.every(term => team.title.toLowerCase().includes(term)));
        }

        return filteredTeam;
    }, [searchText, currentSector, teamMembers]);

    const toggle = (item) => {
        setPopup(true);
        setProfile(item);
    };

    return (
        <>
            <section className='team-archive'>
                <div className='team-archive__inner'>
                    {title && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}
                    <div className="archive__filter" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
                        <form className="filter" onSubmit={handleSubmit}>
                            <div className="filter__select">
                                <Select
                                    openMenuOnFocus={true}
                                    placeholder="Filter"
                                    options={options}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    isSearchable={false}
                                    onChange={(e) => setCurrentSector(e.value)}
                                />
                            </div>
                            <div className="filter__input">
                                <input
                                    onChange={(e) => setSearchText(e.target.value)}
                                    type="text"
                                    id="search"
                                    name="search"
                                    placeholder="Search for something"
                                />
                                <button type="submit">
                                    <Search />
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className='team-archive__items'>
                        {filteredTeam.map((teamMember, index) => (
                            <TeamCard onClick={() => toggle(teamMember)} key={index} {...teamMember} />
                        ))}
                    </div>
                </div>
            </section>

            <div className={`team-overlay ${popup ? 'active' : ''}`} data-lenis-prevent>
                <button onClick={() => setPopup(false)}><Close color='#FFFFFF'/></button>
                <div className='team-overlay__inner'>
                    <div className='team-overlay__content'>
                        {profile?.sector.length > 0 && <span>{profile.sector[0].option}</span>}
                        {profile?.title && <h3>{profile.title}</h3>}
                        {profile?.jobTitle && <h4>{profile.jobTitle}</h4>}
                        {profile?.biography && <StructuredText data={profile.biography}/>}
                    </div>

                    <div className='team-overlay__image'>
                        {profile?.image && <Asset asset={profile.image}/>}
                    </div>
                </div>
            </div>
        </>
    );
}

export default TeamArchive;

export const query = graphql`
  fragment TeamArchiveProps on DatoCmsTeamArchive {
    ... on DatoCmsTeamArchive {
      title
    }
  }
`;